import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import CaptureSession from "../utils/CaptureSession";
import { useTheme, useMediaQuery } from "@mui/material";
import { OutlinedInput } from "@mui/material";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import "dayjs/locale/es";
import Select from "../utils/RecordedSelect";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import HomeIcon from "@mui/icons-material/Home";
import DeleteIcon from "@mui/icons-material/Delete";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import Restricted from "components/Restricted";
import Autocomplete from "@mui/material/Autocomplete";
import { IMaskInput } from "react-imask";
import FormHelperText from "@mui/material/FormHelperText";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { TREATMENT_SCHEMES } from "../utils/preview";
import NutriCaptureControls from "./NutriCaptureControls";
import { contextDefaults } from "../utils/convocatoriaContext";
import NutriDoctorSelect from "./NutriDoctorSelect";
import useNutriMedicamentos from "./useNutriMedicamentos";
import { nutritionAge, resolveM5Nutrition } from "./m5Nutrition";
import { canWriteCapture, useSaludV2Capture } from "../utils/useSaludV2Capture";
import { hydrateV2DataToForm, nutriFormSnapshot, serializeFormToV2Data } from "../utils/nutriSaludAdapter";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box
      sx={{ p: 1, m: 1, fontSize: "0.875rem", fontWeight: "700", ...sx }}
      {...other}
    />
  );
}

Item.propTypes = {
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="+00(#00) 000-0000"
      definitions={{ "#": /[0-9]/ }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const NutriSaludFormV2 = () => {
  return <CaptureSession component={NutriCapture} />;
};

const NutriCapture = ({ onCreated, onNavigationState }) => {
  const tipoActividad = 0;

  const nav = useNavigate();
  const [items, setItems] = React.useState({});

  useEffect(() => {
    try {
      setItems(JSON.parse(localStorage.getItem("token")) || {});
    } catch (error) {
      setItems({});
    }
  }, []);

  const rol = String(items.rol || "");
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  //Modal Styles
  const style = {
    position: "inherit",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 375,
    bgcolor: theme.palette.background.alt,
    border: "2px solid #000",
    borderRadius: 4,
    boxShadow: 1,
    p: 4,
  };

  const [errors, setErrors] = useState({});
  const clearError = (fieldName) => {
    if (errors[fieldName]) {
      setErrors((prev) => ({ ...prev, [fieldName]: undefined }));
    }
  };

  const [fechaNacSalud, setFechaNacSalud] = React.useState(null);
  const [fechaActSalud, setFechaActSalud] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [data, setData] = useState([{ motivoConsulta: "" }]);
  const [activar, setActivar] = useState(true);
  const [data3, setData3] = useState([{ diagnostico: "" }]);
  const oracionFormato = (str) =>
    typeof str === "string"
      ? str
          .toLowerCase()
          .split(" ")
          .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
          .join(" ")
      : "";
  const [estadoSalud, setEstadoSalud] = useState("");
  const [municipioSalud, setMunicipioSalud] = useState("");
  const [parroquiaSalud, setParroquiaSalud] = useState("");
  const [comunidadSalud, setComunidadSalud] = useState("");
  const [estSalud, setEstSalud] = useState("");
  const [valueCedula, setValueCedula] = useState("");
  const [tlf, setValueTlf] = useState({ textmask: "" });
  const [valueRep, setValueRep] = useState("");
  const [valueApellidoRep, setValueApellidoRep] = useState("");
  const [valueNombre, setValueNombre] = useState("");
  const [codigoBeneficiario, setCodigoBeneficiario] = useState("");
  const [valueApellido, setValueApellido] = useState("");
  const [edadSalud, setEdadSalud] = useState("");
  const [edadEnMeses, setEdadEnMeses] = useState(null);
  const [rangoEdadSalud, setRangoEdadSalud] = useState("");
  const [gruposEnfermedad, setGruposEnfermedad] = useState([""]);
  const [convocatoriaContext, setConvocatoriaContext] = useState(null);
  const [comentAdicionales, setValueCA] = useState("");
  const [condicionMujer, setCondicionMujer] = useState("");
  const [semanasGestacion, setSemanasGestacion] = useState("");
  const [codigoGrupoEtnico, setCodigoGrupoEtnico] = useState("");
  const [grupoEtnico, setGrupoEtnico] = useState("");
  const [codigoDisc, setCodigoDisc] = useState("");
  const [valueDisc, setDisc] = useState("");
  const [codigoMovilidad, setCodigoMovilidad] = useState("");
  const [condicionMovilidad, setCondicionMovilidad] = useState("");
  const [codigoFactoresRiesgo, setCodigoFactoresRiesgo] = useState("");
  const [factoresRiesgo, setFactoresRiesgo] = useState("");
  const [codigoFactoresRiesgo2, setCodigoFactoresRiesgo2] = useState("");
  const [factoresRiesgo2, setFactoresRiesgo2] = useState("");
  const [codigoFactoresRiesgo3, setCodigoFactoresRiesgo3] = useState("");
  const [factoresRiesgo3, setFactoresRiesgo3] = useState("");
  const [codigoNivelEducativo, setCodigoNivelEducativo] = useState("");
  const [nivelEducativo, setNivelEducativo] = useState("");
  const [tratamiento, setTratamiento] = useState([]);
  const [inputTratamiento, setInputTratamiento] = useState("");
  const [value, setValue] = useState(null);
  const [valueGenero, setValueGenero] = useState("");
  const [sexoBenef, setSexoBenef] = useState("");
  const [lgbtqi, setLgbtqi] = useState("");
  const [cabezaFamilia, setCabezaFamilia] = useState("");
  const [ingresosPropios, setIngresosPropios] = useState("");
  const [edema, setEdema] = useState("");
  const [cmbM5, setCmbM5] = useState("");
  const [pesoM5, setPesoM5] = useState("");
  const [tallaM5, setTallaM5] = useState("");
  const [puntajezM5, setPuntajeZM5] = useState("");
  const [pzTallaEdadM5, setPzTallaEdadM5] = useState("");
  const [clasificacionTallaEdadM5, setClasificacionTallaEdadM5] = useState("");
  const [consejM5, setConsejM5] = useState("");
  const [referidoM5, setReferidoM5] = useState("");
  const [albendazolM5, setAlbendazolM5] = useState("");
  const [micronutM5, setMicronutM5] = useState("");
  const [lnsmq, setLnsmq] = useState("");
  const [rutfM5, setRutfM5] = useState("");
  const [amoxM5, setAmoxM5] = useState("");
  const [kitHigieneM5, setKitHigieneM5] = useState("");
  const [albendazolDosisM5, setAlbendazolDosisM5] = useState("");
  const [pesoGL, setPesoGL] = useState("");
  const [tallaGL, setTallaGL] = useState("");
  const [imcGL, setImcGL] = useState("");
  const [diagIngresoGL, setDiagIngresoGL] = useState("");
  const [tiempoLactancia, setTiempoLactancia] = useState("");
  const [pbGL, setPbGL] = useState("");
  const [dosisAcidoFolico, setDosisAcidoFolico] = useState("N/A");
  const [dosisSulfatoFerroso, setDosisSulfatoFerroso] = useState("N/A");
  const [dosisPlumpyMum, setDosisPlumpyMum] = useState("N/A");
  const [recordedM5, setRecordedM5] = useState({});
  const baselineRef = useRef({});
  const onHydrate = useCallback((datos) => {
    const ui = hydrateV2DataToForm(datos);
    const setters = {
      fechaNacSalud: setFechaNacSalud, fechaActSalud: setFechaActSalud,
      data: setData, data3: setData3, estadoSalud: setEstadoSalud,
      municipioSalud: setMunicipioSalud, parroquiaSalud: setParroquiaSalud,
      comunidadSalud: setComunidadSalud, estSalud: setEstSalud,
      valueCedula: setValueCedula, tlf: setValueTlf, valueRep: setValueRep,
      valueApellidoRep: setValueApellidoRep, valueNombre: setValueNombre,
      codigoBeneficiario: setCodigoBeneficiario, valueApellido: setValueApellido,
      edadEnMeses: setEdadEnMeses, comentAdicionales: setValueCA,
      condicionMujer: setCondicionMujer, semanasGestacion: setSemanasGestacion,
      codigoGrupoEtnico: setCodigoGrupoEtnico, codigoDisc: setCodigoDisc,
      codigoMovilidad: setCodigoMovilidad, codigoFactoresRiesgo: setCodigoFactoresRiesgo,
      codigoFactoresRiesgo2: setCodigoFactoresRiesgo2,
      codigoFactoresRiesgo3: setCodigoFactoresRiesgo3,
      codigoNivelEducativo: setCodigoNivelEducativo, tratamiento: setTratamiento,
      value: setValue, valueGenero: setValueGenero, sexoBenef: setSexoBenef,
      lgbtqi: setLgbtqi, cabezaFamilia: setCabezaFamilia, ingresosPropios: setIngresosPropios,
      edema: setEdema, cmbM5: setCmbM5, pesoM5: setPesoM5,
      tallaM5: setTallaM5, puntajezM5: setPuntajeZM5,
      consejM5: setConsejM5, referidoM5: setReferidoM5,
      albendazolM5: setAlbendazolM5, micronutM5: setMicronutM5, lnsmq: setLnsmq,
      rutfM5: setRutfM5, amoxM5: setAmoxM5,
      kitHigieneM5: setKitHigieneM5, albendazolDosisM5: setAlbendazolDosisM5,
      pesoGL: setPesoGL, tallaGL: setTallaGL, imcGL: setImcGL,
      diagIngresoGL: setDiagIngresoGL, tiempoLactancia: setTiempoLactancia, pbGL: setPbGL,
    };
    Object.entries(setters).forEach(([key, setter]) => setter(ui[key]));
    setRecordedM5({ edadEnMeses: ui.edadEnMeses, pbM5: ui.pbM5,
      clasificacionNutM5: ui.clasificacionNutM5, diagFinalM5: ui.diagFinalM5 });
    if (!ui.data3.length) setData3([{ diagnostico: "" }]);
    setGruposEnfermedad(ui.tipoEnfermedadIds.length ? ui.tipoEnfermedadIds.map(String) : [""]);
    baselineRef.current = nutriFormSnapshot(ui);
  }, []);
  const capture = useSaludV2Capture("NUTRISALUD", onHydrate, { onCreated });
  const medicamentos = useNutriMedicamentos(convocatoriaContext, capture.convocatoriaId, capture.contextReady && capture.qa.enabled);
  const m5Nutrition = resolveM5Nutrition({
    fechaNacSalud, fechaActSalud, edadEnMeses, cmbM5, puntajezM5, edema,
  }, recordedM5);
  const { pbM5, clasificacionNutM5, diagFinalM5 } = m5Nutrition;
  useEffect(() => onNavigationState({ busy: capture.busy, uncertain: capture.uncertain, dirty: capture.dirty }),
    [onNavigationState, capture.busy, capture.uncertain, capture.dirty]);
  const canWrite = canWriteCapture(rol, items.id, capture.record);
  useEffect(() => {
    if (capture.record || capture.hasPendingSnapshot || !capture.contextReady || String(convocatoriaContext?.id) !== String(capture.convocatoriaId)) return;
    const defaults = contextDefaults(convocatoriaContext);
    const setters = { estado: setEstadoSalud, municipio: setMunicipioSalud,
      parroquia: setParroquiaSalud, centro: setEstSalud, fecha: setFechaActSalud };
    Object.entries(setters).forEach(([key, setter]) => setter(defaults[key]));
  }, [convocatoriaContext, capture.convocatoriaId, capture.contextReady, capture.record, capture.hasPendingSnapshot]);

  const handleClick = () => {
    if (data.length < 5) {
      setData([...data, { motivoConsulta: "" }]);
      setActivar(true);
    }
  };
  const handleChangeInput = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal = data.map((item, index) => index === i ? { ...item, [name]: value } : item);
    setData(onchangeVal);
    clearError("motivoConsulta");
    setActivar(onchangeVal.some((item) => item.motivoConsulta.trim() === ""));
  };
  const handleDelete = (i) => {
    capture.setDirty(true);
    const deleteVal = [...data];
    deleteVal.splice(i, 1);
    setData(deleteVal);
    setActivar(deleteVal.some((item) => item.motivoConsulta.trim() === ""));
  };
  const handleClick3 = () => {
    if (data3.length < 10) {
      setData3([...data3, { diagnostico: "" }]);
    }
  };
  const handleChangeInput3 = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal3 = data3.map((item, index) => index === i ? { ...item, [name]: value } : item);
    setData3(onchangeVal3);
    clearError("diagnostico");
  };
  const handleDelete3 = (i) => {
    capture.setDirty(true);
    const deleteVal3 = [...data3];
    deleteVal3.splice(i, 1);
    setData3(deleteVal3);
  };
  const handleLinkCancelar = () => nav(-1);
  const handleLinkHome = () => nav("/inicio");
  const handleLinkTranscripcion = () => nav(-1);
  const handleTlf = (e) =>
    setValueTlf({ ...tlf, [e.target.name]: e.target.value });
  const handleCodigoGrupoEtnico = (e) => {
    const v = e.target.value;
    clearError("codigoGrupoEtnico");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 7))
      setCodigoGrupoEtnico(v);
  };
  const handleCodigoDisc = (e) => {
    const v = e.target.value;
    clearError("codigoDisc");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 5))
      setCodigoDisc(v);
  };
  const handleCodigoMovilidad = (e) => {
    const v = e.target.value;
    clearError("codigoMovilidad");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 5))
      setCodigoMovilidad(v);
  };
  const handleCodigoFactoresRiesgo = (e) => {
    const v = e.target.value;
    clearError("codigoFactoresRiesgo");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 12))
      setCodigoFactoresRiesgo(v);
  };
  const handleCodigoFactoresRiesgo2 = (e) => {
    const v = e.target.value;
    clearError("codigoFactoresRiesgo2");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 12))
      setCodigoFactoresRiesgo2(v);
  };
  const handleCodigoFactoresRiesgo3 = (e) => {
    const v = e.target.value;
    clearError("codigoFactoresRiesgo3");
    if (v === "" || (parseInt(v, 10) >= 1 && parseInt(v, 10) <= 12))
      setCodigoFactoresRiesgo3(v);
  };
  const handleCodigoNivelEducativo = (e) => {
    const v = e.target.value;
    clearError("codigoNivelEducativo");
    if (v === "" || /^[1-7]$/.test(v))
      setCodigoNivelEducativo(v);
  };
  const handleChangeGenero = (e) => {
    clearError("valueGenero");
    setValueGenero(e.target.value);
  };
  const handleSexoBenef = (e) => {
    const newSexo = e.target.value;
    clearError("sexoBenef");
    setSexoBenef(newSexo);
  };
  const handleCondicionMujer = (e) => {
    const newCondicion = e.target.value;
    setCondicionMujer(newCondicion);
  };
  const handleSemanasGestacion = (e) => setSemanasGestacion(e.target.value);
  const semanasGestacionOptions = Array.from(
    { length: 42 },
    (_, i) => `${i + 1} Semana${i > 0 ? "s" : ""}`,
  );
  const handleTiempoLactancia = (e) => {
    const val = e.target.value;
    if (/^\d{0,2}$/.test(val)) setTiempoLactancia(val);
  };
  const handleLgbtqi = (e) => {
    clearError("lgbtqi");
    setLgbtqi(e.target.value);
  };
  const handleCabezaFamilia = (e) => {
    clearError("cabezaFamilia");
    setCabezaFamilia(e.target.value);
  };
  const handleIngresosPropios = (e) => {
    clearError("ingresosPropios");
    setIngresosPropios(e.target.value);
  };
  const handleChangeEdema = (e) => setEdema(e.target.value);
  const handleCmbM5 = (event) => {
    setCmbM5(event.target.value);
  };
  const handlePuntajeZ = (event) => {
    setPuntajeZM5(event.target.value.replace(/[d]/g, "").slice(0, 6));
  };

  const handleChangeConsejM5 = (e) => setConsejM5(e.target.value);
  const handleReferidoM5 = (e) => setReferidoM5(e.target.value);
  const handleChangeAlbendazolM5 = (e) => setAlbendazolM5(e.target.value);
  const handleChangeMicronutM5 = (e) => setMicronutM5(e.target.value);
  const handleChangeLnsmq = (e) => setLnsmq(e.target.value);
  const handleChangeRutfM5 = (e) => setRutfM5(e.target.value);
  const handleChangeAmoxM5 = (e) => setAmoxM5(e.target.value);
  const handleKitHigieneM5 = (e) => setKitHigieneM5(e.target.value);
  const handleAlbendazolDosisM5 = (e) => setAlbendazolDosisM5(e.target.value);
  const handlePbGL = (e) => {
    const v = e.target.value;
    if (/^\d*\.?\d*$/.test(v)) setPbGL(v);
  };

  useEffect(() => {
    const map = {
      1: "Mestizo",
      2: "Wayuu",
      3: "Añu",
      4: "Japreria",
      5: "Yanomami",
      6: "Bari",
      7: "Yukpa",
    };
    setGrupoEtnico(
      map[codigoGrupoEtnico] || (codigoGrupoEtnico ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoGrupoEtnico]);
  useEffect(() => {
    const map = {
      1: "Física",
      2: "Intelectual",
      3: "Sensorial",
      4: "Múltiple",
      5: "Ninguna",
    };
    setDisc(map[codigoDisc] || (codigoDisc ? "VERIFICAR CÓDIGO" : ""));
  }, [codigoDisc]);
  useEffect(() => {
    const map = {
      1: "Local",
      2: "Desplazado Interno",
      3: "Refugiado",
      4: "Retornado",
      5: "Pendular",
    };
    setCondicionMovilidad(
      map[codigoMovilidad] || (codigoMovilidad ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoMovilidad]);
  useEffect(() => {
    const map = {
      1: "Abuso emocional o psicológico",
      2: "Abuso físico",
      3: "Abuso sexual",
      4: "Embarazo adolescente",
      5: "Explotación sexual",
      6: "Falta de documentos de identidad",
      7: "Matrimonio infantil",
      8: "Negligencia",
      9: "No acompañado (<18 años)",
      10: "Trabajo infantil",
      11: "Trastorno mental",
      12: "No aplica",
    };
    setFactoresRiesgo(
      map[codigoFactoresRiesgo] ||
        (codigoFactoresRiesgo ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoFactoresRiesgo]);
  useEffect(() => {
    const map = {
      1: "Abuso emocional o psicológico",
      2: "Abuso físico",
      3: "Abuso sexual",
      4: "Embarazo adolescente",
      5: "Explotación sexual",
      6: "Falta de documentos de identidad",
      7: "Matrimonio infantil",
      8: "Negligencia",
      9: "No acompañado (<18 años)",
      10: "Trabajo infantil",
      11: "Trastorno mental",
      12: "No aplica",
    };
    setFactoresRiesgo2(
      map[codigoFactoresRiesgo2] ||
        (codigoFactoresRiesgo2 ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoFactoresRiesgo2]);
  useEffect(() => {
    const map = {
      1: "Abuso emocional o psicológico",
      2: "Abuso físico",
      3: "Abuso sexual",
      4: "Embarazo adolescente",
      5: "Explotación sexual",
      6: "Falta de documentos de identidad",
      7: "Matrimonio infantil",
      8: "Negligencia",
      9: "No acompañado (<18 años)",
      10: "Trabajo infantil",
      11: "Trastorno mental",
      12: "No aplica",
    };
    setFactoresRiesgo3(
      map[codigoFactoresRiesgo3] ||
        (codigoFactoresRiesgo3 ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoFactoresRiesgo3]);
  useEffect(() => {
    const map = {
      1: "Prescolar",
      2: "Primaria",
      3: "Secundaria",
      4: "Universitario",
      5: "Sin estudios",
      6: "Analfabeta",
      7: "N/A — No aplica",
    };
    setNivelEducativo(
      map[codigoNivelEducativo] ||
        (codigoNivelEducativo ? "VERIFICAR CÓDIGO" : ""),
    );
  }, [codigoNivelEducativo]);
  const tipoEnfermedadMap = {
    1: "Adulto sano",
    2: "Algunas enfermedades infecciosas o parasitarias",
    3: "Anomalías del desarrollo prenatal",
    4: "Condiciones relacionadas con la salud sexual",
    5: "Embarazo, parto, puerperio o trastornos hormonales",
    6: "Enfermedades de la piel y anexos",
    7: "Enfermedades de la sangre o de los órganos hematopoyéticos",
    8: "Enfermedades de las glándulas mamarias",
    9: "Enfermedades degenerativas",
    10: "Enfermedades del aparato digestivo",
    11: "Enfermedades del aparato genitourinario",
    12: "Enfermedades del aparato respiratorio",
    13: "Enfermedades del ojo y sus anexos",
    14: "Enfermedades del oído o de la apófisis mastoides",
    15: "Enfermedades del sistema circulatorio o cardiovascular",
    16: "Enfermedades del sistema inmunitario",
    17: "Enfermedades del sistema musculoesquelético, de los nervios o del tejido conectivo",
    18: "Enfermedades del sistema nervioso",
    19: "Enfermedades endocrinas, nutricionales o metabólicas",
    20: "Enfermedades odontológicas",
    21: "Factores que influyen en el estado de salud o el contacto con los servicios de salud",
    22: "Neoplasias",
    23: "Niño/adolescente sano",
    24: "Trastornos mentales, del comportamiento y del neurodesarrollo",
    25: "Traumatismos, intoxicaciones u otras consecuencias de causas externas de morbilidad o mortalidad",
    26: "N/A",
  };
  useEffect(() => {
    const pesoNum = parseFloat(pesoGL);
    const tallaNum = parseFloat(tallaGL);
    if (pesoNum > 0 && tallaNum > 0) {
      const tallaMetros = tallaNum / 100;
      const imc = pesoNum / (tallaMetros * tallaMetros);
      setImcGL(imc.toFixed(2));
    } else {
      setImcGL(capture.record?.datos?.mel?.imc ?? "");
    }
  }, [pesoGL, tallaGL, capture.record?.version, capture.record?.id]);

  useEffect(() => {
    const imcNum = parseFloat(imcGL);
    const pbNum = parseFloat(pbGL);
    const numSemanas = parseInt(semanasGestacion, 10) || 0;

    let nuevoDiag = "";

    if (sexoBenef === "Mujer" && condicionMujer === "En Gestación") {
      if (numSemanas > 0 && numSemanas < 20) {
        if (pbNum > 0 && imcNum > 0) {
          if (pbNum < 21.1 && imcNum < 18.5) {
            nuevoDiag = "Bajo Peso";
          } else if (pbNum > 22.1 && imcNum >= 18.5 && imcNum <= 24.99) {
            nuevoDiag = "Peso Adecuado";
          } else {
            if (imcNum < 18.5) nuevoDiag = "Bajo Peso";
            else if (imcNum <= 24.9) nuevoDiag = "Adecuado";
            else if (imcNum <= 29.9) nuevoDiag = "Sobrepeso";
            else nuevoDiag = "Obesidad";
          }
        }
      } else if (numSemanas >= 20) {
        if (pbNum > 0) {
          if (pbNum < 21.1) {
            nuevoDiag = "Bajo Peso";
          } else if (pbNum > 22.1) {
            nuevoDiag = "Peso Adecuado";
          } else {
            nuevoDiag = "Adecuado";
          }
        }
      }
    } else if (sexoBenef === "Mujer" && condicionMujer === "En Lactancia") {
      if (pbNum > 0 && imcNum > 0) {
        if (pbNum > 22.1 && imcNum >= 18.5 && imcNum <= 24.99) {
          nuevoDiag = "Peso Adecuado";
        } else {
          if (imcNum < 18.5) nuevoDiag = "Bajo Peso";
          else if (imcNum <= 24.9) nuevoDiag = "Adecuado";
          else if (imcNum <= 29.9) nuevoDiag = "Sobrepeso";
          else nuevoDiag = "Obesidad";
        }
      }
    }

    setDiagIngresoGL(nuevoDiag || capture.record?.datos?.mel?.diagnosticoIngreso || "");
  }, [imcGL, pbGL, semanasGestacion, sexoBenef, condicionMujer, capture.record?.version, capture.record?.id]);

  const esMenorDe5Anos = (edadEnMeses !== null && edadEnMeses <= 59) || Boolean(capture.record?.datos?.m5);

  useEffect(() => {
    const age = nutritionAge({ fechaNacSalud, fechaActSalud,
      edadEnMeses: recordedM5.edadEnMeses });
    setEdadEnMeses(age.months);
    if (age.years !== undefined) {
        const years = age.years;
        setEdadSalud(`${years} año(s) y ${age.remainderMonths} mes(es)`);
        if (tipoActividad === 3) {
          if (years <= 11) setRangoEdadSalud("0-11 años");
          else if (years <= 17) setRangoEdadSalud("12-17 años");
          else if (years <= 35) setRangoEdadSalud("18-35 años");
          else if (years <= 54) setRangoEdadSalud("36-54 años");
          else setRangoEdadSalud("Mayor de 55 años");
          clearError("valueRep");
          clearError("valueApellidoRep");
        } else {
          if (years <= 4) setRangoEdadSalud("0-4 años");
          else if (years <= 17) setRangoEdadSalud("5-17 años");
          else if (years <= 49) setRangoEdadSalud("18-49 años");
          else setRangoEdadSalud("50 años o más");
        }
    } else {
      setEdadSalud("");
      setRangoEdadSalud("");
    }
  }, [fechaNacSalud, fechaActSalud, tipoActividad, recordedM5.edadEnMeses]);

  const esMujerGestanteOLactante =
    (sexoBenef === "Mujer" &&
    (condicionMujer === "En Gestación" || condicionMujer === "En Lactancia")) || Boolean(capture.record?.datos?.mel);

  const mostrarDosisLactancia =
    esMujerGestanteOLactante &&
    ["Peso Adecuado", "Adecuado", "Bajo Peso"].includes(diagIngresoGL) &&
    (condicionMujer === "En Gestación" ||
      (condicionMujer === "En Lactancia" &&
        tiempoLactancia !== "" &&
        parseInt(tiempoLactancia, 10) <= 6));

  const mostrarDosisPlumpyMum =
    diagIngresoGL === "Bajo Peso" && esMujerGestanteOLactante;

  useEffect(() => {
    if (mostrarDosisLactancia) {
      setDosisAcidoFolico("Ácido fólico 10 mg: 9 blísteres de 10 tabletas");
      setDosisSulfatoFerroso("Sulfato ferroso 300 mg: 9 blísteres de 10 tabletas");
    } else {
      setDosisAcidoFolico("N/A");
      setDosisSulfatoFerroso("N/A");
    }
  }, [mostrarDosisLactancia]);

  useEffect(() => {
    if (mostrarDosisPlumpyMum) {
      setDosisPlumpyMum("Plumpy Doz: 1 sobre diario por 30 días (30 sobres)");
    } else {
      setDosisPlumpyMum("N/A");
    }
  }, [mostrarDosisPlumpyMum]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!canWrite || !capture.qa.enabled || capture.busy) return;
    try {
      const snapshot = nutriFormSnapshot({
        fechaNacSalud, fechaActSalud, data, data3, estadoSalud, municipioSalud,
        parroquiaSalud, comunidadSalud,
        estSalud, valueCedula, tlf, valueRep,
        valueApellidoRep, valueNombre, codigoBeneficiario, valueApellido,
        edadEnMeses, comentAdicionales, condicionMujer, semanasGestacion,
        codigoGrupoEtnico, codigoDisc, codigoMovilidad, codigoFactoresRiesgo,
        codigoFactoresRiesgo2, codigoFactoresRiesgo3, codigoNivelEducativo,
        tipoEnfermedadIds: gruposEnfermedad.filter(value => value !== ""), tratamiento, value, valueGenero,
        sexoBenef, lgbtqi, cabezaFamilia, ingresosPropios, edema, cmbM5,
        pbM5, pesoM5, tallaM5, puntajezM5, clasificacionNutM5, diagFinalM5,
        consejM5, referidoM5, albendazolM5, micronutM5, lnsmq, rutfM5,
        amoxM5, kitHigieneM5, albendazolDosisM5, pesoGL, tallaGL, imcGL,
        diagIngresoGL, tiempoLactancia, pbGL,
      });
      const datos = serializeFormToV2Data(snapshot, capture.record?.datos, baselineRef.current);
      await capture.save(datos);
    } catch (error) {
      capture.setNotice({ severity: "error", text: error.message });
    }
  };

  useEffect(() => {
    if (!capture.dirty) return undefined;
    const beforeUnload = (event) => { event.preventDefault(); event.returnValue = ""; };
    window.addEventListener("beforeunload", beforeUnload);
    return () => window.removeEventListener("beforeunload", beforeUnload);
  }, [capture.dirty]);

  return (
    <Box m="1.5rem 2.5rem">
      {rol && ["1", "2", "6", "8", "9", "10", "11"].includes(rol) ? (
        <>
          <Box>
            <CssBaseline />
            <Box sx={{ mb: 3 }}>
              <Breadcrumbs>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  onClick={handleLinkHome}
                >
                  <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Inicio
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  onClick={handleLinkTranscripcion}
                >
                  <DriveFileRenameOutlineIcon
                    sx={{ mr: 0.5 }}
                    fontSize="inherit"
                  />
                  Transcripción
                </Link>
                <Typography
                  sx={{ display: "flex", alignItems: "center" }}
                  color="text.primary"
                >
                  <NoteAddOutlinedIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  {tipoActividad === 3
                    ? "Nuevo Beneficiario (Salud/Telemedicina)"
                    : "Nuevo Beneficiario (Salud/Nutrición)"}
                </Typography>
              </Breadcrumbs>
              <Typography
                variant="h3"
                sx={{ mt: 3, mb: 1, fontWeight: "bold" }}
              >
                {tipoActividad === 3
                  ? "Nuevo Beneficiario (Salud/Telemedicina)"
                  : "Nuevo Beneficiario (Salud/Nutrición)"}
              </Typography>
              <NutriCaptureControls capture={capture} role={rol} canWrite={canWrite} onContext={setConvocatoriaContext} />
            </Box>
            <Container>
              <Card
                sx={{
                  borderRadius: 8,
                  boxShadow: 5,
                  bgcolor: theme.palette.background.alt,
                }}
              >
                <CardContent>
                  <Box
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}
                    onChangeCapture={() => capture.setDirty(true)}
                    sx={{ mt: 3 }}
                  >
                    <fieldset disabled={!canWrite || !capture.qa.enabled || capture.busy || capture.uncertain} style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>
                    <Box>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="INFO. GENERAL" />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            label="Estado"
                            value={estadoSalud}
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            label="Municipio"
                            value={municipioSalud}
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            label="Parroquia"
                            value={parroquiaSalud}
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            label="Comunidad"
                            value={estSalud}
                            InputProps={{ readOnly: true }}
                            inputProps={{ "aria-label": "Comunidad de la convocatoria" }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField fullWidth label="Fecha de Atención"
                            value={fechaActSalud && dayjs(fechaActSalud).isValid() ? dayjs(fechaActSalud).format("DD/MM/YYYY") : ""}
                            InputProps={{ readOnly: true }} />
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="DATOS DEL BENEFICIARIO" />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="Codigo"
                            fullWidth
                            value={codigoBeneficiario}
                            onChange={(e) => {
                              setCodigoBeneficiario(
                                oracionFormato(e.target.value),
                              );
                              clearError("codigoBeneficiario");
                            }}
                            error={!!errors.codigoBeneficiario}
                            helperText={errors.codigoBeneficiario}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="Primer Nombre"
                            fullWidth
                            value={valueNombre}
                            onChange={(e) => {
                              setValueNombre(oracionFormato(e.target.value));
                              clearError("valueNombre");
                            }}
                            error={!!errors.valueNombre}
                            helperText={errors.valueNombre}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="Primer Apellido"
                            fullWidth
                            value={valueApellido}
                            onChange={(e) => {
                              setValueApellido(oracionFormato(e.target.value));
                              clearError("valueApellido");
                            }}
                            error={!!errors.valueApellido}
                            helperText={errors.valueApellido}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.sexoBenef}>
                            <InputLabel id="sexo">Sexo</InputLabel>
                            <Select disabled={!canWrite || !capture.qa.enabled || capture.busy || capture.uncertain} onEdit={() => capture.setDirty(true)}
                              value={sexoBenef}
                              label="Sexo"
                              onChange={handleSexoBenef}
                            >
                              <MenuItem value={"Mujer"}>Mujer</MenuItem>
                              <MenuItem value={"Hombre"}>Hombre</MenuItem>
                            </Select>
                            {errors.sexoBenef && (
                              <FormHelperText>
                                {errors.sexoBenef}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.valueGenero}>
                            <InputLabel id="genero">Género</InputLabel>
                            <Select disabled={!canWrite || !capture.qa.enabled || capture.busy || capture.uncertain} onEdit={() => capture.setDirty(true)}
                              value={valueGenero}
                              label="Género"
                              onChange={handleChangeGenero}
                            >
                              <MenuItem value={"Femenino"}>Femenino</MenuItem>
                              <MenuItem value={"Masculino"}>Masculino</MenuItem>
                              <MenuItem value={"Otro"}>Otro</MenuItem>
                            </Select>
                            {errors.valueGenero && (
                              <FormHelperText>
                                {errors.valueGenero}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="cedula"
                            fullWidth
                            id="cedula"
                            label="Cédula de Identidad"
                            value={valueCedula}
                            onChange={(e) =>
                              setValueCedula(
                                e.target.value
                                  .replace(/[^\d]/g, "")
                                  .slice(0, 10),
                              )
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth>
                            <InputLabel htmlFor="telefono">Teléfono</InputLabel>
                            <OutlinedInput
                              value={tlf.textmask}
                              onChange={handleTlf}
                              name="textmask"
                              id="telefono"
                              inputComponent={TextMaskCustom}
                              label="Teléfono"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                          >
                            <DesktopDatePicker
                              label="Fecha de Nacimiento"
                              inputFormat="DD/MM/YYYY"
                              value={fechaNacSalud}
                              onChange={(v) => {
                                setFechaNacSalud(v);
                                capture.setDirty(true);
                                clearError("fechaNacSalud");
                              }}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  {...params}
                                  error={!!errors.fechaNacSalud}
                                  helperText={errors.fechaNacSalud}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={tipoActividad === 3 ? 2 : 4}>
                          <TextField
                            label="Edad"
                            fullWidth
                            disabled
                            value={edadSalud}
                          />
                        </Grid>
                        <Grid item xs={12} sm={2} hidden={tipoActividad !== 3}>
                          <TextField
                            label="Grupo Etario"
                            fullWidth
                            disabled
                            value={rangoEdadSalud}
                          />
                        </Grid>
                        {sexoBenef === "Mujer" && (
                          <>
                            <Grid item xs={12} sm={4}>
                              <FormControl fullWidth>
                                <InputLabel id="condicion-mujer-label">
                                  Condición
                                </InputLabel>
                                <Select disabled={!canWrite || !capture.qa.enabled || capture.busy || capture.uncertain} onEdit={() => capture.setDirty(true)}
                                  labelId="condicion-mujer-label"
                                  value={condicionMujer}
                                  label="Condición"
                                  onChange={handleCondicionMujer}
                                >
                                  <MenuItem value={"En Gestación"}>
                                    En Gestación
                                  </MenuItem>
                                  <MenuItem value={"En Lactancia"}>
                                    En Lactancia
                                  </MenuItem>
                                  <MenuItem value={"No Aplica"}>
                                    No Aplica
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            {condicionMujer === "En Gestación" && (
                              <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                  <InputLabel id="semanas-gestacion-label">
                                    Semanas de Gestación
                                  </InputLabel>
                                  <Select disabled={!canWrite || !capture.qa.enabled || capture.busy || capture.uncertain} onEdit={() => capture.setDirty(true)}
                                    labelId="semanas-gestacion-label"
                                    value={semanasGestacion}
                                    label="Semanas de Gestación"
                                    onChange={handleSemanasGestacion}
                                  >
                                    <MenuItem value="">
                                      <em>Seleccionar...</em>
                                    </MenuItem>
                                    {semanasGestacionOptions.map((s) => (
                                      <MenuItem key={s} value={s}>
                                        {s}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                            )}
                            {condicionMujer === "En Lactancia" && (
                              <Grid item xs={12} sm={4}>
                                <TextField
                                  label="Tiempo de Lactancia (Meses)"
                                  type="number"
                                  fullWidth
                                  value={tiempoLactancia}
                                  onChange={handleTiempoLactancia}
                                  inputProps={{ maxLength: 2 }}
                                />
                              </Grid>
                            )}
                          </>
                        )}
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="DATOS DEL REPRESENTANTE" />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            name="representante"
                            fullWidth
                            label="Primer Nombre"
                            disabled={!edadEnMeses || edadEnMeses >= 216}
                            value={valueRep}
                            onChange={(e) => {
                              setValueRep(oracionFormato(e.target.value));
                              clearError("valueRep");
                            }}
                            error={!!errors.valueRep}
                            helperText={errors.valueRep}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Primer Apellido"
                            value={valueApellidoRep}
                            disabled={!edadEnMeses || edadEnMeses >= 216}
                            onChange={(e) => {
                              setValueApellidoRep(
                                oracionFormato(e.target.value),
                              );
                              clearError("valueApellidoRep");
                            }}
                            error={!!errors.valueApellidoRep}
                            helperText={errors.valueApellidoRep}
                          />
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip
                          label="DATOS DEMOGRÁFICOS DEL BENEFICIARIO"
                          sx={{
                            "&.MuiChip-root": {
                              fontSize: isSmallScreen ? "9px" : "auto",
                            },
                          }}
                        />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.lgbtqi}>
                            <InputLabel id="lgbtqi">LGBTQI+</InputLabel>
                            <Select disabled={!canWrite || !capture.qa.enabled || capture.busy || capture.uncertain} onEdit={() => capture.setDirty(true)}
                              value={lgbtqi}
                              label="LGBTQI+"
                              onChange={handleLgbtqi}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                            {errors.lgbtqi && (
                              <FormHelperText>{errors.lgbtqi}</FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            label="Comunidad"
                            value={comunidadSalud}
                            onChange={(e) => {
                              setComunidadSalud(oracionFormato(e.target.value));
                              clearError("comunidadSalud");
                            }}
                            error={!!errors.comunidadSalud}
                            helperText={errors.comunidadSalud}
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            fullWidth
                            error={!!errors.codigoGrupoEtnico}
                            label="Código"
                            type="number"
                            value={codigoGrupoEtnico}
                            onChange={handleCodigoGrupoEtnico}
                            helperText={errors.codigoGrupoEtnico}
                            inputProps={{ min: 1, max: 7, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={grupoEtnico === "VERIFICAR CÓDIGO"}
                            label="Grupo Etnico"
                            value={grupoEtnico}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            fullWidth
                            type="number"
                            error={!!errors.codigoDisc}
                            label="Código"
                            value={codigoDisc}
                            onChange={handleCodigoDisc}
                            helperText={errors.codigoDisc}
                            inputProps={{ min: 1, max: 5, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={valueDisc === "VERIFICAR CÓDIGO"}
                            label="Discapacidad"
                            value={valueDisc}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            fullWidth
                            type="number"
                            error={!!errors.codigoMovilidad}
                            label="Código"
                            value={codigoMovilidad}
                            onChange={handleCodigoMovilidad}
                            helperText={errors.codigoMovilidad}
                            inputProps={{ min: 1, max: 5, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={condicionMovilidad === "VERIFICAR CÓDIGO"}
                            label="Condición de Movilidad"
                            value={condicionMovilidad}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            fullWidth
                            type="number"
                            error={!!errors.codigoFactoresRiesgo}
                            label="Código"
                            value={codigoFactoresRiesgo}
                            onChange={handleCodigoFactoresRiesgo}
                            helperText={errors.codigoFactoresRiesgo}
                            inputProps={{ min: 1, max: 12, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={factoresRiesgo === "VERIFICAR CÓDIGO"}
                            label="Factor de Riesgo 1"
                            value={factoresRiesgo}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            fullWidth
                            type="number"
                            error={!!errors.codigoFactoresRiesgo2}
                            label="Código"
                            value={codigoFactoresRiesgo2}
                            onChange={handleCodigoFactoresRiesgo2}
                            helperText={errors.codigoFactoresRiesgo2}
                            inputProps={{ min: 1, max: 12, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={factoresRiesgo2 === "VERIFICAR CÓDIGO"}
                            label="Factor de Riesgo 2"
                            value={factoresRiesgo2}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            fullWidth
                            type="number"
                            error={!!errors.codigoFactoresRiesgo3}
                            label="Código"
                            value={codigoFactoresRiesgo3}
                            onChange={handleCodigoFactoresRiesgo3}
                            helperText={errors.codigoFactoresRiesgo3}
                            inputProps={{ min: 1, max: 12, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={factoresRiesgo3 === "VERIFICAR CÓDIGO"}
                            label="Factor de Riesgo 3"
                            value={factoresRiesgo3}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            fullWidth
                            type="number"
                            error={!!errors.codigoNivelEducativo}
                            label="Código educativo"
                            value={codigoNivelEducativo}
                            onChange={handleCodigoNivelEducativo}
                            helperText={errors.codigoNivelEducativo}
                            inputProps={{ min: 1, max: 7, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={nivelEducativo === "VERIFICAR CÓDIGO"}
                            label="Nivel Educativo"
                            value={nivelEducativo}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.cabezaFamilia}>
                            <InputLabel id="cabezaFamilia">
                              Cabeza de Familia
                            </InputLabel>
                            <Select disabled={!canWrite || !capture.qa.enabled || capture.busy || capture.uncertain} onEdit={() => capture.setDirty(true)}
                              value={cabezaFamilia}
                              labelId="cabezaFamilia"
                              label="Cabeza de Familia"
                              onChange={handleCabezaFamilia}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value="No aplica">No aplica</MenuItem>
                              <MenuItem value="">Sin informar</MenuItem>
                            </Select>
                            {errors.cabezaFamilia && (
                              <FormHelperText>
                                {errors.cabezaFamilia}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl
                            fullWidth
                            error={!!errors.ingresosPropios}
                          >
                            <InputLabel id="ingresosPropios">
                              Ingresos Propios
                            </InputLabel>
                            <Select disabled={!canWrite || !capture.qa.enabled || capture.busy || capture.uncertain} onEdit={() => capture.setDirty(true)}
                              value={ingresosPropios}
                              labelId="ingresosPropios"
                              label="Ingresos Propios"
                              onChange={handleIngresosPropios}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                              <MenuItem value="No aplica">No aplica</MenuItem>
                              <MenuItem value="">Sin informar</MenuItem>
                            </Select>
                            {errors.ingresosPropios && (
                              <FormHelperText>
                                {errors.ingresosPropios}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 2 }}>
                        <Chip label="DATOS DE CONSULTA Y MANEJO" />
                      </Divider>
                      <div style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: isSmallScreen ? "column" : "row",
                          }}
                        >
                          <Item sx={{ width: "100%" }}>
                            {data.map((val, i) => (
                              <div key={i}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    xs={data.length === 1 ? 12 : 9}
                                    sm={10}
                                    mt={1}
                                  >
                                    <TextField
                                      fullWidth
                                      label="Motivo de Consulta"
                                      name="motivoConsulta"
                                      value={val.motivoConsulta}
                                      onChange={(e) => handleChangeInput(e, i)}
                                      error={
                                        !!errors.motivoConsulta &&
                                        !val.motivoConsulta.trim()
                                      }
                                      helperText={
                                        !!errors.motivoConsulta &&
                                        !val.motivoConsulta.trim()
                                          ? "No puede estar vacío"
                                          : ""
                                      }
                                    />
                                  </Grid>
                                  {data.length > 1 && (
                                    <Grid item xs={2} sm={1}>
                                      <Tooltip title="Eliminar">
                                        <IconButton
                                          size="large"
                                          color="error"
                                          onClick={() => handleDelete(i)}
                                        >
                                          <DeleteIcon fontSize="inherit" />
                                        </IconButton>
                                      </Tooltip>
                                    </Grid>
                                  )}
                                </Grid>
                              </div>
                            ))}
                            <Grid container>
                              <Grid item xs={12} sm={3} sx={{ mt: 3 }}>
                                <Button
                                  variant="contained"
                                  disabled={activar}
                                  sx={{
                                    bgcolor: "teal",
                                    color: "white",
                                    borderRadius: 2,
                                  }}
                                  fullWidth
                                  onClick={handleClick}
                                  hidden={data.length === 5}
                                >
                                  Añadir Más
                                </Button>
                              </Grid>
                            </Grid>
                          </Item>
                          <Item sx={{ width: "100%" }}>
                            {data3.map((val3, i) => (
                              <div key={i}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    xs={data3.length === 1 ? 12 : 9}
                                    sm={10}
                                    mt={1}
                                  >
                                    <TextField
                                      fullWidth
                                      label="Diagnóstico"
                                      name="diagnostico"
                                      value={val3.diagnostico}
                                      onChange={(e) => handleChangeInput3(e, i)}
                                      error={
                                        !!errors.diagnostico &&
                                        !val3.diagnostico.trim()
                                      }
                                      helperText={
                                        !!errors.diagnostico &&
                                        !val3.diagnostico.trim()
                                          ? "No puede estar vacío"
                                          : ""
                                      }
                                    />
                                  </Grid>
                                  {data3.length > 1 && (
                                    <Grid item xs={2} sm={1}>
                                      <Tooltip title="Eliminar">
                                        <IconButton
                                          size="large"
                                          color="error"
                                          onClick={() => handleDelete3(i)}
                                        >
                                          <DeleteIcon fontSize="inherit" />
                                        </IconButton>
                                      </Tooltip>
                                    </Grid>
                                  )}
                                </Grid>
                              </div>
                            ))}
                            <Grid container>
                              <Grid
                                item
                                xs={isSmallScreen ? 12 : 8}
                                sm={3}
                                sx={{ mt: 3 }}
                              >
                                <Button
                                  variant="contained"
                                  disabled={data3.some(item => !item.diagnostico.trim() && !item.conceptoId)}
                                  sx={{
                                    bgcolor: "teal",
                                    color: "white",
                                    borderRadius: 2,
                                  }}
                                  hidden={data3.length >= 10}
                                  fullWidth
                                  onClick={handleClick3}
                                >
                                  Añadir Más
                                </Button>
                              </Grid>
                            </Grid>
                          </Item>
                        </Box>
                      </div>
                      <div style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: isSmallScreen ? "column" : "row",
                          }}
                        >
                          <Item sx={{ width: "100%" }}>
                            {gruposEnfermedad.map((codigo, index) => <Grid container spacing={1} key={index} sx={{ mb: 2 }}>
                              <Grid item xs={3}>
                                <TextField fullWidth type="number" label={`Código de grupo ${index + 1}`} value={codigo}
                                  inputProps={{ min: 1, max: 26, step: 1 }}
                                  onChange={event => {
                                    const next = event.target.value;
                                    if (next === "" || /^(?:[1-9]|1\d|2[0-6])$/.test(next)) {
                                      capture.setDirty(true);
                                      setGruposEnfermedad(old => old.map((value, i) => i === index ? next : value));
                                    }
                                  }} />
                              </Grid>
                              <Grid item xs={gruposEnfermedad.length > 1 ? 7 : 9}>
                                <TextField fullWidth label={`Grupo de enfermedad ${index + 1}`} disabled
                                  value={tipoEnfermedadMap[codigo] || (codigo ? "VERIFICAR CÓDIGO" : "")} />
                              </Grid>
                              {gruposEnfermedad.length > 1 && <Grid item xs={2}>
                                <Tooltip title="Eliminar grupo"><IconButton aria-label={`Eliminar grupo ${index + 1}`} color="error" onClick={() => {
                                  capture.setDirty(true);
                                  setGruposEnfermedad(old => old.filter((_, i) => i !== index));
                                }}><DeleteIcon /></IconButton></Tooltip>
                              </Grid>}
                            </Grid>)}
                            <Button disabled={gruposEnfermedad.length >= 10} onClick={() => {
                              capture.setDirty(true);
                              setGruposEnfermedad(old => [...old, ""]);
                            }}>Añadir grupo</Button>
                          </Item>
                          <Item sx={{ width: "100%" }}>
                            <div>
                              <Grid
                                container
                                spacing={2}
                                sx={{ mt: !isSmallScreen ? 1 : 0 }}
                              >
                                <Grid item xs={12} sm={10}>
                                  <Autocomplete
                                    multiple
                                    freeSolo
                                    fullWidth
                                    name="tratamiento"
                                    value={tratamiento}
                                    onChange={(e, nv) => {
                                      capture.setDirty(true);
                                      setTratamiento(nv);
                                      if (nv.length > 0)
                                        clearError("tratamiento");
                                    }}
                                    inputValue={inputTratamiento}
                                    onInputChange={(e, niv) =>
                                      setInputTratamiento(niv)
                                    }
                                    options={medicamentos.options}
                                    loading={medicamentos.loading}
                                    loadingText="Cargando medicamentos..."
                                    noOptionsText="Sin medicamentos disponibles"
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Tratamiento indicado"
                                        fullWidth
                                        error={!!errors.tratamiento}
                                        helperText={errors.tratamiento || medicamentos.error ||
                                          (medicamentos.loading ? "Cargando medicamentos..." :
                                            medicamentos.ready && !medicamentos.options.length ? "No hay medicamentos asignados a este proyecto." : "")}
                                      />
                                    )}
                                  />
                                </Grid>
                              </Grid>
                            </div>
                            <br />
                          </Item>
                        </Box>
                      </div>

                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="TRATAMIENTO AL INGRESO" />
                      </Divider>

                      {esMenorDe5Anos && (
                        <>
                          <Divider sx={{ mt: 4, mb: 3 }}>
                            <Chip label="INFO. NUTRICIONAL (0-59 MESES)" />
                          </Divider>
                          <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12} sm={2}>
                              <FormControl>
                                <FormLabel>Edema</FormLabel>
                                <RadioGroup
                                  row
                                  value={edema}
                                  onChange={handleChangeEdema}
                                >
                                  <FormControlLabel
                                    value="Si"
                                    control={<Radio />}
                                    label="Si"
                                  />
                                  <FormControlLabel
                                    value="No"
                                    control={<Radio />}
                                    label="No"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <TextField
                                label="Circ. de Brazo (CMB)"
                                fullWidth
                                value={cmbM5}
                                onChange={handleCmbM5}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <TextField
                                label="Clasificación PB"
                                fullWidth
                                value={pbM5}
                                helperText={m5Nutrition.notes.pbM5}
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <TextField
                                label="Peso (Kg)"
                                fullWidth
                                value={pesoM5}
                                onChange={(e) => setPesoM5(e.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <TextField
                                label="Talla (cm)"
                                fullWidth
                                value={tallaM5}
                                onChange={(e) => setTallaM5(e.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <TextField
                                label="Puntaje Z"
                                fullWidth
                                value={puntajezM5}
                                onChange={handlePuntajeZ}
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <TextField
                                label="Clasificación Nutricional"
                                fullWidth
                                value={clasificacionNutM5}
                                helperText={m5Nutrition.notes.clasificacionNutM5}
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                              <TextField
                                label="Diagnóstico de Ingreso"
                                fullWidth
                                value={diagFinalM5}
                                helperText={m5Nutrition.notes.diagFinalM5}
                                disabled
                              />
                            </Grid>
                          </Grid>
                          <Divider sx={{ mt: 4 }}>
                            <Chip label="TRATAMIENTO" />
                          </Divider>
                          <Grid
                            container
                            spacing={2}
                            justifyContent="center"
                            sx={{ mt: 1 }}
                          >
                            <Grid item xs={12} sm={3} mt={3}>
                              <FormControl>
                                <FormLabel>Referido</FormLabel>
                                <RadioGroup
                                  row
                                  value={referidoM5}
                                  onChange={handleReferidoM5}
                                >
                                  <FormControlLabel
                                    value="Si"
                                    control={<Radio />}
                                    label="Si"
                                  />
                                  <FormControlLabel
                                    value="No"
                                    control={<Radio />}
                                    label="No"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3} mt={3}>
                              <FormControl>
                                <FormLabel>RUTF (Sobre Rojo)</FormLabel>
                                <RadioGroup
                                  row
                                  value={
                                    micronutM5 === "Si" || lnsmq === "Si"
                                      ? "No"
                                      : rutfM5
                                  }
                                  onChange={handleChangeRutfM5}
                                >
                                  <FormControlLabel
                                    value="Si"
                                    control={<Radio />}
                                    label="Si"
                                    disabled={
                                      micronutM5 === "Si" ||
                                      lnsmq === "Si" ||
                                      referidoM5 === "Si"
                                    }
                                  />
                                  <FormControlLabel
                                    value="No"
                                    control={<Radio />}
                                    label="No"
                                    disabled={
                                      micronutM5 === "Si" ||
                                      lnsmq === "Si" ||
                                      referidoM5 === "Si"
                                    }
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={3} mt={3}>
                              <FormControl>
                                <FormLabel>Kit de Higiene</FormLabel>
                                <RadioGroup
                                  row
                                  value={kitHigieneM5}
                                  onChange={handleKitHigieneM5}
                                >
                                  <FormControlLabel
                                    value="Si"
                                    control={<Radio />}
                                    label="Si"
                                  />
                                  <FormControlLabel
                                    value="No"
                                    control={<Radio />}
                                    label="No"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Grid>
                          </Grid>
                          <Divider sx={{ mt: 4, mb: 3 }}>
                            <Chip label="DOSIS" />
                          </Divider>
                          <Typography
                            variant="h5"
                            align="center"
                            mt={4}
                            hidden={
                              (albendazolM5 === "Si" ||
                                micronutM5 === "Si" ||
                                lnsmq === "Si" ||
                                rutfM5 === "Si") &&
                              diagFinalM5 !== ""
                            }
                            sx={{ color: "gray" }}
                          >
                            <InfoOutlinedIcon sx={{ color: "gray" }} /> Sin dosis
                            confirmadas en esta vista previa.
                          </Typography>
                          <Grid
                            container
                            spacing={2}
                            sx={{ mt: 1 }}
                            justifyContent="center"
                            hidden={rutfM5 !== "Si"}
                          >
                            {["mam", "sam"].map(key => <Grid item xs={12} sm={6} key={key}>
                              <Typography variant="subtitle2">{TREATMENT_SCHEMES[key].title}</Typography>
                              {TREATMENT_SCHEMES[key].items.map(item => <Typography key={item} variant="body2">{item}</Typography>)}
                            </Grid>)}
                          </Grid>
                        </>
                      )}

                      {esMujerGestanteOLactante && (
                        <>
                          <Divider sx={{ mt: 4, mb: 3 }}>
                            <Chip label="INFO. NUTRICIONAL (GESTANTE/LACTANTE)" />
                          </Divider>
                          <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12} sm={3}>
                              <TextField
                                label="Peso (Kg)"
                                fullWidth
                                value={pesoGL}
                                onChange={(e) => setPesoGL(e.target.value)}
                                type="number"
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <TextField
                                label="Talla (cm)"
                                fullWidth
                                value={tallaGL}
                                onChange={(e) => setTallaGL(e.target.value)}
                                type="number"
                              />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <TextField
                                label="PB"
                                fullWidth
                                value={pbGL}
                                onChange={handlePbGL}
                                type="number"
                              />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <TextField
                                label="IMC"
                                fullWidth
                                value={imcGL}
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              <TextField
                                label="Diagnóstico de Ingreso"
                                fullWidth
                                value={diagIngresoGL}
                                disabled
                              />
                            </Grid>
                          </Grid>
                        </>
                      )}

                      {mostrarDosisLactancia && (
                        <>
                          <Divider sx={{ mt: 4, mb: 3 }}>
                            <Chip label="DOSIS (GESTACIÓN/LACTANCIA)" />
                          </Divider>
                          <Grid container spacing={2} justifyContent="center">
                            <Grid
                              item
                              xs={12}
                              sm={mostrarDosisPlumpyMum ? 6 : 6}
                            >
                              <TextField
                                label="Ácido fólico"
                                fullWidth
                                disabled
                                value={dosisAcidoFolico}
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={mostrarDosisPlumpyMum ? 6 : 6}
                            >
                              <TextField
                                label="Sulfato ferroso"
                                fullWidth
                                disabled
                                value={dosisSulfatoFerroso}
                              />
                            </Grid>
                            {mostrarDosisPlumpyMum && (
                              <Grid item xs={12} sm={6}>
                                <TextField
                                  label="Plumpy Doz"
                                  fullWidth
                                  disabled
                                  value={dosisPlumpyMum}
                                />
                              </Grid>
                            )}
                          </Grid>
                        </>
                      )}

                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="ADICIONALES" />
                      </Divider>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12} sm={6}>
                          <NutriDoctorSelect value={value}
                            disabled={!canWrite || !capture.qa.enabled || capture.busy || capture.uncertain}
                            onChange={(next) => {
                              capture.setDirty(true);
                              setValue(next);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Comentarios"
                            value={comentAdicionales}
                            fullWidth
                            multiline
                            maxRows={4}
                            onChange={(e) =>
                              setValueCA(oracionFormato(e.target.value))
                            }
                          />
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 5 }} />
                      <Grid
                        container
                        sx={{ mt: 2 }}
                        spacing={1}
                        justifyContent="center"
                      >
                        <Grid item sm={3} xs={6}>
                          <Button
                            variant="contained"
                            color="error"
                            size="large"
                            fullWidth
                            onClick={handleOpen}
                          >
                            Cancelar
                          </Button>
                        </Grid>
                        <Grid item sm={3} xs={6}>
                          <Button
                            type="submit"
                            variant="contained"
                            sx={{ bgcolor: "teal", color: "white" }}
                          size="large"
                          fullWidth
                          disabled={!capture.contextReady || !canWrite || capture.busy || capture.conflict}
                        >
                            Guardar atención
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                    </fieldset>
                  </Box>
                </CardContent>
              </Card>
              <Modal
                open={open}
                onClose={handleClose}
                slotProps={{ backdrop: { style: { opacity: 0.2 } } }}
              >
                <Box sx={style}>
                  <Typography variant="h6" align="center" sx={{ mb: 1.5 }}>
                    ¿Está seguro de cancelar esta operación?
                  </Typography>
                  <Divider sx={{ mt: 2 }} />
                  <Grid
                    container
                    sx={{ mt: 1 }}
                    spacing={1}
                    justifyContent="flex-end"
                  >
                    <Grid item>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                      >
                        No
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        sx={{ bgcolor: "teal", color: "white" }}
                        onClick={handleLinkCancelar}
                      >
                        Si
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
            </Container>
          </Box>
        </>
      ) : (
        <Restricted />
      )}
    </Box>
  );
};

export default NutriSaludFormV2;
